<template>
  <div class="d-flex">
    <div>
      <el-form ref="ruleForm" :model="form">

        <el-form-item>
          <a :href="tempFile" target="_blank" class="download">下载著作权许可书模板</a>
          &nbsp;&nbsp;&nbsp;
          <a href="/static/demo_dx.jpg" target="_blank" class="download">下载著作权许可书示例</a>
        </el-form-item>

        <el-form-item prop="attachCode">
          <el-upload drag v-model="form.attachCode" :action="uploadURL" :before-upload="uploadBefore" ref="fileUpload"
            :multiple="false" name="file" list-type="text" :file-list="uploadFilelist" :limit="1" :headers="uploadHeaders"
            :on-success="uploadSuccess">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div slot="tip" class="el-upload__tip" style="line-height: 150%;">只能上传图片文件，且不超过5MB
              <div style="color:#d83218">请正确填写并上传清晰图片，否则会影响您的文章后期上传知网等合作网站。</div></div>
            <div></div>
          </el-upload>
        </el-form-item>

      </el-form>
    </div>
    <div style="margin-left: 30px;">
      <a href="/static/demo_dx.jpg" target="_blank">
        <img src="/static/demo_dx.jpg" style="width:100%;" /></a>
    </div>
  </div>
</template>

<script>

import http from "@/api/http"
import authorApi from "@/api/author";
import { getToken } from "@/utils/auth"
//import VueOfficeDocx from '@vue-office/docx'

export default {
  name: "FormArticleUpload",
  props: {
    articleId: {
      type: Number,
      require: true,
    },
  },

  data() {
    return {
      form: {
        attachId: 0,
        attachCode: "",
      },
      uploadFilelist: [],
      uploadURL: "",
      uploadHeaders: { Authorization: getToken() },
      status: 0,
      uploadFlag: false,
      tempFile:'/static/license_'+process.env.VUE_APP_PLATFORM+'.docx',
    }
  },

  created() {
    this.uploadURL = http.defaults.baseURL + "attach/uploadCopyright?articleId="+this.articleId
  },

  methods: {
    uploadBefore(file) {
      const isPIC = file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/gif"
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isPIC) {
        this.$alert("上传文件必须是图片 格式!", "系统提示", {
          confirmButtonText: "确定",
        })
        return false
      }
      if (!isLt5M) {
        this.$alert("上传文件不能超过 5MB!", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      return isPIC && isLt5M
    },

    uploadSuccess(res) {
      if (res.code == 1) {
        this.$alert("上传失败,请重新上传", "异常提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
        this.$refs.fileUpload.clearFiles()
      } else {
        this.uploadFlag = true
        this.form.attachId = res.data.attachId
        this.form.attachCode = res.data.attachCode
        this.$refs.ruleForm.validateField("attachCode")
        
        this.submit(this.articleId,res.data.attachId,res.data.attachCode);
      }
    },

    submit(articleId, attachId, attachCode) {
      authorApi.postLicense(articleId, attachId, attachCode).then((res) => {

        //this.btnLoading = false;
        if (res.code == 0) {
          this.drawer = false
          this.$notify.success({
            title: "成功",
            message: "登记成功！",
          })
          this.$emit("submitSuccess");
        } else {
          this.$notify.error({
            title: "错误",
            message: res.msg,
          })
        }
      })
    },

  },
}
</script>